<script setup lang="ts">
import { defineOptions, defineProps } from 'vue';

defineOptions({ name: 'GenericCard' });

const props = defineProps({
  title: { type: String, required: true },
  className: { type: String, required: false },
})
</script>

<template>
  <div class="flex flex-col items-center" :class="props.className">
    <div class="rounded-lg shadow-lg border border-gray-300 max-w-full">
      <h1 id="titulo" class="text-2xl text-center text-primary-900 font-bold p-4 pb-0">{{ props.title }}</h1>
      <hr class="my-4 border-gray-200" />
      <div class="p-4 pt-0">
        <slot />
      </div>
    </div>
  </div>
</template>
